import React, { useState, useContext, useEffect } from "react";
import LoaderAnimation from "./LoaderAnimation";
import { NavigationContext } from "navigation-react";
import loginImage from "./images/loginImage.jpg";
import anihlogoimage from "./images/idcnewlogo.png";
import "./styles.css";
import SecureLS from "secure-ls";
import MessageModal from "./MessageModal";
import { faCheckCircle, faClose } from "@fortawesome/free-solid-svg-icons";

const ls = new SecureLS({ encodingType: "aes" });

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const [sessionToken, setSessionToken] = useState("");

  const { stateNavigator } = useContext(NavigationContext);

  const [isMessageModalVisibleAddRequest, setIsMessageModalVisibleAddRequest] =
    useState(false);
  const toggleModalClose = () => {
    setIsMessageModalVisibleAddRequest(false);
  };

  // Fetch session token on component mount
  useEffect(() => {
    const existingUserId = ls.get("currentuserid");
    const existingUserRole = ls.get("currentuserrole");

    if (existingUserId && existingUserRole) {
      // console.log("User already logged in, redirecting to dashboard...");
      stateNavigator.navigate("dashboardcontent");
    }

    const fetchSessionToken = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_SESSION_API}`, {
          method: "GET",
          credentials: "include",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(
            `Failed to fetch session token: ${response.statusText}`
          );
        }

        const token = await response.text();
        setSessionToken(token);
        ls.set("session_token", token);
        console.log("Session Token:", token);
      } catch (error) {
        console.error("Session Token Fetch Error:", error);
      }
    };

    fetchSessionToken();
  }, [stateNavigator]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!username.trim()) {
      alert("Please enter a username");
      return;
    }

    if (!password.trim()) {
      alert("Please enter a password");
      return;
    }

    setLoading(true);

    try {
      const loginResponse = await fetch(`${process.env.REACT_APP_LOGIN_URL}`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": sessionToken,
        },
        body: JSON.stringify({ name: username, pass: password }),
      });

      if (!loginResponse.ok) {
        const errorResponse = await loginResponse.json();
        alert(`Login failed: ${errorResponse.message || "Unknown error"}`);
        // throw new Error(`HTTP error! Status: ${loginResponse.status}`);
      }

      const loginData = await loginResponse.json();
      console.log("Login successful:", loginData);

      // Store credentials securely before user role fetch
      ls.set("username", loginData.current_user.name);
      ls.set("usercsrf_token", loginData.csrf_token);
      ls.set("userlogout_token", loginData.logout_token);
      ls.set("userpw", password);
      ls.set("currentuserid", loginData.current_user.uid);
      ls.set("currentuserrole", loginData.current_user.roles);

      setIsMessageModalVisibleAddRequest(true);

      // Wait a moment to show the success modal before navigating
      setTimeout(() => {
        stateNavigator.navigate("dashboardcontent");
      }, 1500); // show modal for 1.5 seconds
    } catch (error) {
      console.error("Login Error:", error);
      alert(`Error: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <LoaderAnimation />;
  }

  return (
    <div className="mainLoginWrapper">
      <div className="logoImageWrapper">
        <div className="logoImage">
          <img src={anihlogoimage} alt="Logo" />
        </div>
      </div>

      <div className="login-page">
        <div className="login-container">
          <div className="form-section">
            <h2>Login</h2>
            <form onSubmit={handleSubmit} className="login-form">
              <div className="form-group">
                <label htmlFor="username">Username:</label>
                <input
                  type="text"
                  id="username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="password">Password:</label>
                <input
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>

              <button type="submit" disabled={loading} className="login-button">
                {loading ? "Logging in..." : "Login"}
              </button>
            </form>
          </div>

          <div className="image-section">
            <img src={loginImage} alt="Login" />
          </div>
        </div>
      </div>
      {isMessageModalVisibleAddRequest && (
        <MessageModal
          leftIcon={faCheckCircle}
          color="green"
          fontSize={20}
          message="Login successful!"
          onClose={toggleModalClose}
          rightIcon={faClose}
        />
      )}
    </div>
  );
};

export default Login;
